// JAWS reads SVG path/title content unless aria-hidden (see doc/jaws-voiceover-accessibility-reference.md §6).

import React from 'react'
import YnsIcon from '../icons/YnsIcon'

export const RedX = () => {
  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width="15"
      height="15"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="#a94442"
      className="h-6 w-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6 18 18 6M6 6l12 12"
      />
    </svg>
  )
}

export const GreenCheck = () => {
  return (
    <svg
      aria-hidden="true"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.76691 11.8345L1.21092 7.17002L0 8.7472L4.76691 15L15 1.57718L13.7976 0L4.76691 11.8345Z"
        fill="#148335"
      />
    </svg>
  )
}

export const PaperClip = () => {
  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M17 6V17.5C17 18.5609 16.5786 19.5783 15.8284 20.3284C15.0783 21.0786 14.0609 21.5 13 21.5C11.9391 21.5 10.9217 21.0786 10.1716 20.3284C9.42143 19.5783 9 18.5609 9 17.5V5C9 4.33696 9.26339 3.70107 9.73223 3.23223C10.2011 2.76339 10.837 2.5 11.5 2.5C12.163 2.5 12.7989 2.76339 13.2678 3.23223C13.7366 3.70107 14 4.33696 14 5V15.5C14 15.7652 13.8946 16.0196 13.7071 16.2071C13.5196 16.3946 13.2652 16.5 13 16.5C12.7348 16.5 12.4804 16.3946 12.2929 16.2071C12.1054 16.0196 12 15.7652 12 15.5V6H10.5V15.5C10.5 16.163 10.7634 16.7989 11.2322 17.2678C11.7011 17.7366 12.337 18 13 18C13.663 18 14.2989 17.7366 14.7678 17.2678C15.2366 16.7989 15.5 16.163 15.5 15.5V5C15.5 3.93913 15.0786 2.92172 14.3284 2.17157C13.5783 1.42143 12.5609 1 11.5 1C10.4391 1 9.42172 1.42143 8.67157 2.17157C7.92143 2.92172 7.5 3.93913 7.5 5V17.5C7.5 18.9587 8.07946 20.3576 9.11091 21.3891C10.1424 22.4205 11.5413 23 13 23C14.4587 23 15.8576 22.4205 16.8891 21.3891C17.9205 20.3576 18.5 18.9587 18.5 17.5V6H17Z"
        fill="white"
      />
    </svg>
  )
}

export const LeafIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35.4166 16.6667C16.6666 20.8333 12.2916 33.6875 7.95829 44.4583L11.8958 45.8333L13.875 41.0417C14.875 41.3958 15.9166 41.6667 16.6666 41.6667C39.5833 41.6667 45.8333 6.25 45.8333 6.25C43.75 10.4167 29.1666 10.9375 18.75 13.0208C8.33329 15.1042 4.16663 23.9583 4.16663 28.125C4.16663 32.2917 7.81246 35.9375 7.81246 35.9375C14.5833 16.6667 35.4166 16.6667 35.4166 16.6667Z"
        fill="#148335"
      />
    </svg>
  )
}

export const PlantIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M43.7458 6.25V10.4167C43.7458 14.2844 42.2094 17.9937 39.4745 20.7286C36.7395 23.4635 33.0302 25 29.1625 25H27.0791V27.0833H37.4958V41.6667C37.4958 42.7717 37.0568 43.8315 36.2754 44.6129C35.494 45.3944 34.4342 45.8333 33.3291 45.8333H16.6625C15.5574 45.8333 14.4976 45.3944 13.7162 44.6129C12.9348 43.8315 12.4958 42.7717 12.4958 41.6667V27.0833H22.9125V20.8333C22.9125 16.9656 24.4489 13.2563 27.1838 10.5214C29.9187 7.78646 33.6281 6.25 37.4958 6.25H43.7458ZM11.4541 4.16667C13.9541 4.16464 16.4179 4.7633 18.6382 5.91224C20.8585 7.06118 22.7702 8.72676 24.2125 10.7688C22.0124 13.6623 20.8237 17.1984 20.8291 20.8333V22.9167H19.7875C15.6435 22.9167 11.6692 21.2705 8.73893 18.3402C5.80868 15.41 4.16248 11.4357 4.16248 7.29167V4.16667H11.4541Z"
        fill="#148335"
      />
    </svg>
  )
}

export const TreeIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2073_7140)">
        <path
          d="M26.4729 4.77709C26.0822 4.38652 25.5524 4.16711 25 4.16711C24.4476 4.16711 23.9178 4.38652 23.5271 4.77709L15.1938 13.1104C14.8779 13.4263 14.6719 13.8354 14.6063 14.2773C14.5406 14.7192 14.6188 15.1705 14.8292 15.5646C15.3438 16.5292 16.1479 17.1792 16.9333 17.6208L11.0271 23.5271C10.6365 23.9178 10.4171 24.4476 10.4171 25C10.4171 25.5524 10.6365 26.0822 11.0271 26.4729C12.0229 27.4688 13.2813 28.0771 14.4313 28.4563L8.94376 33.9438C8.69222 34.1955 8.50938 34.5076 8.41269 34.8501C8.31599 35.1926 8.30865 35.5542 8.39138 35.9004C8.47411 36.2465 8.64414 36.5657 8.88526 36.8275C9.12638 37.0893 9.43055 37.285 9.76876 37.3958C11.2063 37.8688 12.6917 38.2042 14.175 38.5C15.8 38.8271 17.8125 39.15 20.1021 39.3583L18.8563 43.0917C18.7519 43.4049 18.7235 43.7384 18.7734 44.0647C18.8233 44.391 18.95 44.7008 19.143 44.9686C19.3361 45.2363 19.5901 45.4543 19.884 45.6047C20.1778 45.755 20.5032 45.8334 20.8333 45.8333H29.1667C29.4968 45.8334 29.8222 45.755 30.1161 45.6047C30.4099 45.4543 30.6639 45.2363 30.857 44.9686C31.0501 44.7008 31.1767 44.391 31.2266 44.0647C31.2765 43.7384 31.2481 43.4049 31.1438 43.0917L29.8979 39.3583C32.1896 39.15 34.2021 38.8271 35.825 38.5021C37.3083 38.2042 38.8042 37.8688 40.2417 37.3937C40.5787 37.2815 40.8814 37.085 41.121 36.8228C41.3607 36.5607 41.5293 36.2416 41.611 35.8959C41.6926 35.5502 41.6845 35.1894 41.5874 34.8477C41.4903 34.506 41.3075 34.1949 41.0563 33.9438L35.5688 28.4563C36.7188 28.0792 37.9771 27.4688 38.9729 26.4729C39.3635 26.0822 39.5829 25.5524 39.5829 25C39.5829 24.4476 39.3635 23.9178 38.9729 23.5271L33.0667 17.6208C33.8521 17.1792 34.6563 16.5292 35.1708 15.5646C35.3812 15.1705 35.4594 14.7192 35.3937 14.2773C35.3281 13.8354 35.1221 13.4263 34.8063 13.1104L26.4729 4.77709Z"
          fill="#148335"
        />
      </g>
      <defs>
        <clipPath id="clip0_2073_7140">
          <rect width="50" height="50" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IntooLogo = () => {
  return (
    <svg
      width="47"
      height="39"
      viewBox="0 0 47 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.7734 25.4054C17.5302 26.2438 15.4177 26.6247 13.4938 26.5664C11.5836 26.5183 9.85564 26.0425 8.34475 25.1709C6.58098 24.17 5.11644 22.6156 4.01119 20.5704C3.49702 19.6084 3.42748 18.667 4.41157 18.0745C5.43885 17.4706 6.39554 18.2953 7.04247 19.3888C7.60721 20.3473 8.21726 21.1618 8.89158 21.8458C8.91686 21.8847 8.95796 21.9155 8.99905 21.9544C10.2286 23.1749 11.6531 23.9253 13.2704 24.1266C14.6433 24.3119 16.1595 24.1174 17.8316 23.5032C23.9099 21.2761 23.3747 15.2207 19.5237 14.6968C23.617 15.0925 24.7718 23.0376 19.7734 25.4054Z"
        fill="url(#paint0_linear_1240_2583)"
      />
      <path
        d="M30.0042 36.9917C21.4435 40.9905 11.8755 39.3434 8.79159 29.0866C8.41755 27.849 8.28268 26.521 8.3459 25.1689C9.85574 26.044 11.5847 26.521 13.4918 26.5656C13.5592 26.9854 13.6604 27.4086 13.7752 27.8249C13.8111 27.9736 13.8542 28.1212 13.9038 28.2619C16.0268 35.1512 24.2809 39.8821 31.1779 36.3969C30.7934 36.6062 30.4014 36.8018 30.0042 36.9917Z"
        fill="url(#paint1_linear_1240_2583)"
      />
      <path
        d="M19.171 14.6651C19.0857 14.664 19.0067 14.656 18.9203 14.6629C14.2432 14.5553 10.4829 17.8462 9.00147 21.9571C8.95827 21.9182 8.91507 21.8851 8.89294 21.8439C10.4681 16.111 15.2463 10.9843 20.7884 11.8387C26.7034 12.7492 28.6473 22.1001 19.7748 25.4046C24.7711 23.0392 23.6173 15.0941 19.5251 14.696C19.4987 14.6834 19.465 14.6869 19.4387 14.688C19.3523 14.68 19.2648 14.672 19.171 14.6651Z"
        fill="url(#paint2_linear_1240_2583)"
      />
      <path
        d="M18.9192 14.6627C15.8331 14.7531 13.2475 19.126 13.2697 24.128C11.6502 23.9244 10.2278 23.1786 9.00037 21.957C10.4828 17.846 14.2421 14.5552 18.9192 14.6627Z"
        fill="url(#paint3_linear_1240_2583)"
      />
      <path
        d="M39.3571 15.2185C41.4676 15.6212 43.9341 18.9989 42.4095 23.381C40.9787 27.4896 37.1308 33.1551 31.1852 36.3956H31.1779C24.2808 39.882 16.0267 35.1511 13.9037 28.2606C15.679 33.8093 21.3907 36.8016 25.8476 34.5231C32.8647 30.9417 34.1828 19.477 34.1828 19.477C34.6032 16.9171 36.5029 14.6718 39.3571 15.2185Z"
        fill="url(#paint4_linear_1240_2583)"
      />
      <path
        d="M46.3512 4.87613C47.0687 8.25846 45.1237 11.6305 42.0071 12.4095C38.8936 13.1884 35.7854 11.0769 35.0679 7.69455C34.3514 4.31222 36.2975 0.940186 39.412 0.161232C42.5286 -0.616578 45.6357 1.49495 46.3512 4.87613Z"
        fill="url(#paint5_linear_1240_2583)"
      />
      <path
        d="M4.12399 13.3338C4.38213 14.5554 3.68147 15.7713 2.55725 16.0527C1.43303 16.3341 0.311975 15.5711 0.053837 14.3507C-0.205355 13.1302 0.496359 11.9131 1.62058 11.6318C2.74479 11.3515 3.86585 12.1133 4.12399 13.3338Z"
        fill="url(#paint6_linear_1240_2583)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1240_2583"
          x1="22.9786"
          y1="21.3087"
          x2="3.61118"
          y2="19.6346"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00541A" />
          <stop offset="0.319" stopColor="#7DC24B" />
          <stop offset="0.4591" stopColor="#77BD4A" />
          <stop offset="0.6087" stopColor="#6AB346" />
          <stop offset="0.7627" stopColor="#53A441" />
          <stop offset="0.9188" stopColor="#318F3A" />
          <stop offset="1" stopColor="#148335" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1240_2583"
          x1="16.0705"
          y1="14.3599"
          x2="22.497"
          y2="40.09"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00152F" />
          <stop offset="0.1168" stopColor="#004260" />
          <stop offset="0.2361" stopColor="#006992" />
          <stop offset="0.3373" stopColor="#0088BA" />
          <stop offset="0.4151" stopColor="#009CD6" />
          <stop offset="0.4601" stopColor="#00A5E5" />
          <stop offset="0.5169" stopColor="#009FDB" />
          <stop offset="0.5919" stopColor="#0093CA" />
          <stop offset="0.6773" stopColor="#0080B0" />
          <stop offset="0.7703" stopColor="#00668E" />
          <stop offset="0.8694" stopColor="#004767" />
          <stop offset="0.9722" stopColor="#00233C" />
          <stop offset="1" stopColor="#00152F" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1240_2583"
          x1="7.60978"
          y1="21.4655"
          x2="27.4718"
          y2="17.2563"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#005C97" />
          <stop offset="0.5" stopColor="#00AAD3" />
          <stop offset="1" stopColor="#005C97" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1240_2583"
          x1="13.2607"
          y1="15.0101"
          x2="19.8502"
          y2="41.3925"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00152F" />
          <stop offset="0.5" stopColor="#00AAD3" />
          <stop offset="1" stopColor="#002055" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1240_2583"
          x1="20.284"
          y1="35.7233"
          x2="42.8985"
          y2="14.8043"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00541A" />
          <stop offset="0.0882" stopColor="#0F6524" />
          <stop offset="0.2364" stopColor="#347F31" />
          <stop offset="0.3871" stopColor="#4E973B" />
          <stop offset="0.5383" stopColor="#62A942" />
          <stop offset="0.6903" stopColor="#70B647" />
          <stop offset="0.8435" stopColor="#79BE4A" />
          <stop offset="1" stopColor="#7DC24B" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1240_2583"
          x1="35.0688"
          y1="7.69482"
          x2="46.4382"
          y2="5.2854"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7DC24B" />
          <stop offset="0.1844" stopColor="#75BC49" />
          <stop offset="0.432" stopColor="#63AF45" />
          <stop offset="0.7156" stopColor="#459B3E" />
          <stop offset="1" stopColor="#148335" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_1240_2583"
          x1="4.28203"
          y1="9.1492"
          x2="0.57911"
          y2="15.8722"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7DC24B" />
          <stop offset="0.1844" stopColor="#75BC49" />
          <stop offset="0.432" stopColor="#63AF45" />
          <stop offset="0.7156" stopColor="#459B3E" />
          <stop offset="1" stopColor="#148335" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export const SolarCase = ({ active = false }) => {
  if (active) {
    return (
      <svg
        className="h-[30px] w-[30px] md:h-[56px] md:w-[56px]"
        viewBox="0 0 75 75"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.375 37.5C9.375 49.2844 9.375 61.4281 13.4937 65.0875C17.6125 68.75 24.2437 68.75 37.5 68.75C50.7594 68.75 57.3875 68.75 61.5062 65.0875C65.625 61.4281 65.625 49.2844 65.625 37.5"
          stroke="white"
          strokeWidth="1"
        />
        <path
          d="M45.8125 44.3812L64.5875 38.75C66.4469 38.1906 67.3781 37.9125 67.9687 37.2438C68.0845 37.1132 68.189 36.9731 68.2812 36.825C68.75 36.0656 68.75 35.0969 68.75 33.1531C68.75 25.4969 68.75 21.6687 66.6469 19.0844C66.2424 18.5871 65.7879 18.1326 65.2906 17.7281C62.7062 15.625 58.8781 15.625 51.2219 15.625H23.7812C16.125 15.625 12.2969 15.625 9.7125 17.7281C9.2125 18.1344 8.75937 18.5875 8.35625 19.0844C6.25 21.6687 6.25 25.4969 6.25 33.1531C6.25 35.0969 6.25 36.0656 6.71875 36.825C6.8125 36.9719 6.91562 37.1125 7.03125 37.2438C7.625 37.9125 8.55312 38.1906 10.4125 38.75L29.1875 44.3812M20.3125 15.625C22.8844 15.5625 25.5 13.9219 26.375 11.5L26.4844 11.1781L26.5625 10.9375C26.6937 10.5406 26.7625 10.3437 26.8312 10.1687C27.2727 9.07129 28.0165 8.12164 28.9763 7.43016C29.9361 6.73869 31.0724 6.33378 32.2531 6.2625C32.4375 6.25 32.65 6.25 33.0625 6.25H41.9312C42.3469 6.25 42.5562 6.25 42.7437 6.2625C43.9245 6.33378 45.0608 6.73869 46.0206 7.43016C46.9803 8.12164 47.7242 9.07129 48.1656 10.1687C48.2375 10.3437 48.3031 10.5437 48.4344 10.9375L48.5156 11.1781C48.5719 11.3437 48.5969 11.4281 48.625 11.5C49.5 13.9219 52.1125 15.5625 54.6844 15.625"
          stroke="white"
          strokeWidth="1"
        />
        <path
          d="M43.75 39.0625H31.25C30.8356 39.0625 30.4382 39.2271 30.1451 39.5201C29.8521 39.8132 29.6875 40.2106 29.6875 40.625V47.3812C29.6876 47.6933 29.7811 47.9982 29.956 48.2566C30.1308 48.515 30.3791 48.7152 30.6688 48.8313L32.8562 49.7063C35.8372 50.899 39.1628 50.899 42.1437 49.7063L44.3312 48.8313C44.6209 48.7152 44.8692 48.515 45.044 48.2566C45.2189 47.9982 45.3124 47.6933 45.3125 47.3812V40.625C45.3125 40.2106 45.1479 39.8132 44.8549 39.5201C44.5618 39.2271 44.1644 39.0625 43.75 39.0625Z"
          stroke="white"
          strokeWidth="1"
          strokeLinecap="round"
        />
      </svg>
    )
  } else {
    return (
      <svg
        className="h-[30px] w-[30px] md:h-[56px] md:w-[56px]"
        viewBox="0 0 33 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.375 16.5C3.375 21.9994 3.375 27.6665 5.29708 29.3742C7.21917 31.0833 10.3138 31.0833 16.5 31.0833C22.6877 31.0833 25.7808 31.0833 27.7029 29.3742C29.625 27.6665 29.625 21.9994 29.625 16.5"
          stroke="black"
          strokeWidth="1"
        />
        <path
          d="M20.3792 19.7113L29.1409 17.0834C30.0086 16.8223 30.4432 16.6925 30.7188 16.3804C30.7728 16.3195 30.8216 16.2541 30.8647 16.185C31.0834 15.8306 31.0834 15.3786 31.0834 14.4715C31.0834 10.8986 31.0834 9.1121 30.102 7.90606C29.9132 7.67399 29.7011 7.4619 29.469 7.27314C28.263 6.29169 26.4765 6.29169 22.9036 6.29169H10.098C6.52508 6.29169 4.73862 6.29169 3.53258 7.27314C3.29925 7.46273 3.08779 7.67419 2.89966 7.90606C1.91675 9.1121 1.91675 10.8986 1.91675 14.4715C1.91675 15.3786 1.91675 15.8306 2.1355 16.185C2.17925 16.2536 2.22737 16.3192 2.28133 16.3804C2.55841 16.6925 2.99154 16.8223 3.85925 17.0834L12.6209 19.7113M8.47925 6.29169C9.67946 6.26252 10.9001 5.4969 11.3084 4.36669L11.3595 4.21648L11.3959 4.10419C11.4572 3.91898 11.4892 3.8271 11.5213 3.74544C11.7273 3.23329 12.0745 2.79012 12.5224 2.46743C12.9702 2.14474 13.5005 1.95578 14.0515 1.92252C14.1376 1.91669 14.2367 1.91669 14.4292 1.91669H18.568C18.762 1.91669 18.8597 1.91669 18.9472 1.92252C19.4982 1.95578 20.0285 2.14474 20.4764 2.46743C20.9242 2.79012 21.2714 3.23329 21.4774 3.74544C21.5109 3.8271 21.5415 3.92044 21.6028 4.10419L21.6407 4.21648C21.667 4.29377 21.6786 4.33315 21.6917 4.36669C22.1001 5.4969 23.3192 6.26252 24.5195 6.29169"
          stroke="black"
          strokeWidth="1"
        />
        <path
          d="M19.4167 17.2292H13.5834C13.39 17.2292 13.2046 17.3061 13.0678 17.4428C12.9311 17.5796 12.8542 17.765 12.8542 17.9584V21.1113C12.8543 21.257 12.8979 21.3992 12.9795 21.5198C13.0611 21.6404 13.177 21.7338 13.3122 21.788L14.333 22.1963C15.7241 22.753 17.2761 22.753 18.6672 22.1963L19.688 21.788C19.8232 21.7338 19.939 21.6404 20.0206 21.5198C20.1022 21.3992 20.1459 21.257 20.1459 21.1113V17.9584C20.1459 17.765 20.0691 17.5796 19.9323 17.4428C19.7956 17.3061 19.6101 17.2292 19.4167 17.2292Z"
          stroke="black"
          strokeWidth="1"
          strokeLinecap="round"
        />
      </svg>
    )
  }
}

export const PathArrow = ({ active = false }) => {
  if (active) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-[30px] w-[30px] md:h-[56px] md:w-[56px]"
        viewBox="0 0 24 24"
        strokeWidth=".75"
        fill="none"
        color="white"
      >
        <path
          d="M18 16.5V3M18 3L21.5 6.5M18 3L14.5 6.5"
          stroke="white"
          strokeWidth=".75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 16.5C18 18.433 16.433 20 14.5 20C12.567 20 11 18.433 11 16.5V7.5"
          stroke="white"
          strokeWidth=".75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 7.5C11 5.567 9.433 4 7.5 4C5.567 4 4 5.567 4 7.5V19.5"
          stroke="white"
          strokeWidth=".75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  } else {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-[30px] w-[30px] md:h-[56px] md:w-[56px]"
        viewBox="0 0 24 24"
        strokeWidth=".75"
        fill="none"
        color="black"
      >
        <path
          d="M18 16.5V3M18 3L21.5 6.5M18 3L14.5 6.5"
          stroke="black"
          strokeWidth=".75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 16.5C18 18.433 16.433 20 14.5 20C12.567 20 11 18.433 11 16.5V7.5"
          stroke="black"
          strokeWidth=".75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 7.5C11 5.567 9.433 4 7.5 4C5.567 4 4 5.567 4 7.5V19.5"
          stroke="black"
          strokeWidth=".75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export const JournalPage = ({ active = false }) => {
  if (active) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-[30px] w-[30px] md:h-[56px] md:w-[56px]"
        viewBox="0 0 24 24"
        strokeWidth=".75"
        fill="none"
        color="white"
      >
        <path
          d="M6 6L14 6"
          stroke="white"
          strokeWidth=".75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 10H18"
          stroke="white"
          strokeWidth=".75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13 14L18 14"
          stroke="white"
          strokeWidth=".75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13 18L18 18"
          stroke="white"
          strokeWidth=".75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 21.4V2.6C2 2.26863 2.26863 2 2.6 2H18.2515C18.4106 2 18.5632 2.06321 18.6757 2.17574L21.8243 5.32426C21.9368 5.43679 22 5.5894 22 5.74853V21.4C22 21.7314 21.7314 22 21.4 22H2.6C2.26863 22 2 21.7314 2 21.4Z"
          stroke="white"
          strokeWidth=".75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 18V14H9V18H6Z"
          stroke="white"
          strokeWidth=".75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 2V5.4C18 5.73137 18.2686 6 18.6 6H22"
          stroke="white"
          strokeWidth=".75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  } else {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-[30px] w-[30px] md:h-[56px] md:w-[56px]"
        viewBox="0 0 24 24"
        strokeWidth=".75"
        fill="none"
        color="black"
      >
        <path
          d="M6 6L14 6"
          stroke="black"
          strokeWidth=".75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 10H18"
          stroke="black"
          strokeWidth=".75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13 14L18 14"
          stroke="black"
          strokeWidth=".75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13 18L18 18"
          stroke="black"
          strokeWidth=".75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 21.4V2.6C2 2.26863 2.26863 2 2.6 2H18.2515C18.4106 2 18.5632 2.06321 18.6757 2.17574L21.8243 5.32426C21.9368 5.43679 22 5.5894 22 5.74853V21.4C22 21.7314 21.7314 22 21.4 22H2.6C2.26863 22 2 21.7314 2 21.4Z"
          stroke="black"
          strokeWidth=".75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 18V14H9V18H6Z"
          stroke="black"
          strokeWidth=".75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 2V5.4C18 5.73137 18.2686 6 18.6 6H22"
          stroke="black"
          strokeWidth=".75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export const RetirementIcon = ({ active = false }) => {
  if (active) {
    return (
      <YnsIcon
        name="retirement"
        className="h-[30px] w-[30px] stroke-[.75] text-white md:h-[56px] md:w-[56px]"
      />
    )
  } else {
    return (
      <YnsIcon
        name="retirement"
        className="h-[30px] w-[30px] stroke-[.75] text-black md:h-[56px] md:w-[56px]"
      />
    )
  }
}

export const EntrepreneurshipIcon = ({ active = false }) => {
  if (active) {
    return (
      <YnsIcon
        name="entrepreneurship"
        className="h-[30px] w-[30px] stroke-[.75] text-white md:h-[56px] md:w-[56px]"
      />
    )
  } else {
    return (
      <YnsIcon
        name="entrepreneurship"
        className="h-[30px] w-[30px] stroke-[.75] text-black md:h-[56px] md:w-[56px]"
      />
    )
  }
}
